import { html } from "haunted";
import i18next from "i18next";
import { useState, useEffectWithoutCleanup } from "Shared/haunted/CustomHooks";
import { HauntedFunc } from "Shared/haunted/HooksHelpers";
import { PUB_SUBS } from "Services/pub-sub-service/PubSub";
import { deleteLoginInfo } from "Services/common";
import { iconButton } from "Components/iconButton";

export const name = "ac-chile-compra-login-info-modal";
export const useShadowDOM = false;

export const Component: HauntedFunc<{}> = () => {
	const [isOpen, setIsOpen] = useState(false);

	const init = () => {
		const handler = PUB_SUBS.ChileCompraLoginInfoModalOpened.subscribe(() => setIsOpen(true));

		return () => handler.unsubscribe();
	};

	const handleAcceptButton = async () => {
		try {
			await deleteLoginInfo();
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error("Could not delete login info", e);
		}
		setIsOpen(false);
	};

	const acceptButton = iconButton({
		isAction: true,
		icon: html`<i class="jsh-circle-chevron-right1 text-base"></i>`,
		label: i18next.t("Aceptar"),
		onClick: handleAcceptButton,
	});

	useEffectWithoutCleanup(init, []);

	return isOpen
		? html`
				<div class="fixed inset-0 z-[100001] bg-n-blue bg-opacity-75 backdrop-blur-sm">
					<div
						class="absolute !w-[550px] max-w-[95%] overflow-hidden rounded-2xl bg-white all-center"
						data-test-id="modal-content"
					>
						<div class="modal-body">
							<div class="flex w-full justify-center py-3">
								<i class="jsh-icon jsh-broken-circle-exclamation text-[100px] text-be-cyan-2"></i>
							</div>
							<div class="px-6 text-center font-body leading-snug text-be-blue-2">
								${i18next.t("ChileCompraModalText")}
							</div>
						</div>
						<div class="flex w-full justify-center p-6">${acceptButton.htmlTemplate()}</div>
					</div>
				</div>
		  `
		: html``;
};
